export interface FormData {
  issueType: string;
  description: string;
  businessUnit?: string;
  shouldIncludeBusinessUnit?: boolean;
}

export interface ValidationErrors {
  issueType?: string;
  description?: string;
  businessUnit?: string;
}

export const ISSUE_TYPE_KEYS = {
  MISSING_BOID: "contact-support.issue-types.missing-boid",
  INCORRECT_BOID_MAPPING: "contact-support.issue-types.incorrect-boid-mapping",
  REMOVE_INACTIVE_BOID: "contact-support.issue-types.remove-inactive-boid",
  DUPLICATE_COORG_ENTITIES:
    "contact-support.issue-types.duplicate-coorg-entities",
  COMPLEX_COMMON_ORG_ENTITY:
    "contact-support.issue-types.complex-common-org-entity",
  HIERARCHY_TENANT_MAPPING:
    "contact-support.issue-types.hierarchy-tenant-mapping",
  ADDRESS_INCORRECT: "contact-support.issue-types.address-incorrect",
  PHONE_INCORRECT: "contact-support.issue-types.phone-incorrect",
  OEM_UPDATE_NEEDED: "contact-support.issue-types.oem-update-needed",
  OTHER_MISCELLANEOUS: "contact-support.issue-types.other-miscellaneous"
} as const;

export const BOID_RELATED_ISSUE_KEYS = [
  "MISSING_BOID",
  "INCORRECT_BOID_MAPPING",
  "REMOVE_INACTIVE_BOID"
] as const;

export const PLACEHOLDER_KEY_MAP: Record<string, string> = {
  MISSING_BOID: "contact-support.placeholders.missing-boid",
  INCORRECT_BOID_MAPPING: "contact-support.placeholders.incorrect-boid-mapping",
  REMOVE_INACTIVE_BOID: "contact-support.placeholders.remove-inactive-boid",
  DUPLICATE_COORG_ENTITIES:
    "contact-support.placeholders.duplicate-coorg-entities",
  COMPLEX_COMMON_ORG_ENTITY:
    "contact-support.placeholders.complex-common-org-entity",
  HIERARCHY_TENANT_MAPPING:
    "contact-support.placeholders.hierarchy-tenant-mapping",
  ADDRESS_INCORRECT: "contact-support.placeholders.address-incorrect",
  PHONE_INCORRECT: "contact-support.placeholders.phone-incorrect",
  OEM_UPDATE_NEEDED: "contact-support.placeholders.oem-update-needed",
  OTHER_MISCELLANEOUS: "contact-support.placeholders.other-miscellaneous"
};

export const INITIAL_FORM_STATE: FormData = {
  issueType: "",
  description: ""
};

// Validation constants
export const MIN_DESCRIPTION_LENGTH = 10;
export const MAX_DESCRIPTION_LENGTH = 32000;

// Validation error message keys
export const VALIDATION_ERROR_KEYS = {
  ISSUE_TYPE_REQUIRED: "contact-support.validation.issue-type-required",
  DESCRIPTION_REQUIRED: "contact-support.validation.description-required",
  DESCRIPTION_TOO_SHORT: "contact-support.validation.description-too-short",
  DESCRIPTION_TOO_LONG: "contact-support.validation.description-too-long",
  BUSINESS_UNIT_REQUIRED: "contact-support.validation.business-unit-required"
} as const;
